<div class="portal--main">
    <div class="module-wrapper">
        <div class="dash-grid">
            <div class="dash-grid--item half module drop-shadow bottom">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">What <button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button type="button" (click)="editWhat()" class="focus-element"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main module--main__column">
                    <div class="block-num text-center">
                        <svg class="ic ic__lg"><use xlink:href="#ic-get" href="#ic-get"></use></svg>
                        <span class="md">{{interactonData.what.type.key}}</span>
                    </div>
                </div>
            </div>
            <div class="dash-grid--item half module drop-shadow bottom">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">When <button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button type="button" (click)="editWhen()" class="focus-element"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main module--main__column">
                    <div class="block-num text-center">
                        <svg class="ic ic__lg"><use xlink:href="#ic-calendar-dark" href="#ic-calendar-dark"></use></svg>
                        <span class="md">Scheduled for <br> {{interactonData.when.date ? (interactonData.when.date | date:'EEEE d LLLL yyyy, HH:mm') : 'Now'}}</span>
                    </div>
                </div>
            </div>
            <div class="dash-grid--item half module drop-shadow bottom">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">Who <button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button type="button" (click)="editWho()" class="focus-element"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main module--main__column">
                    <div class="block-num text-center">
                        <svg class="ic ic__lg"><use xlink:href="#ic-account2-dark" href="#ic-account2-dark"></use></svg>
                        <span class="md">{{interactonData.who.consumerIds.length}} accounts</span>
                    </div>
                </div>
            </div>

            <div class="dash-grid--item half module summary__module bottom" *ngIf="bulkState == 'updatestandingcharges'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">Updated standing charge<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main no-border">
                    <div class="block-num text-center">
                        <svg class="ic"><use xlink:href="#ic-house" href="#ic-house"></use></svg>
                        <h2 class="subheading-sm">Standing Charge</h2>
                        <div class="summary__module--flex summary__module--flex__column__md">
                            <div class="flex--item">
                                <span class="lg">£{{interactonData.how.pastValue}} <span class="md u-display u-display__inline-block">per kWh</span></span>
                                <span class="md">Current standing charge</span>
                            </div>
                            <div class="flex--item"></div>
                            <div class="flex--item">
                                <span class="lg">£{{interactonData.how.value}} <span class="md u-display u-display__inline-block">per kWh</span></span>
                                <span class="md">Updated standing charge</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dash-grid--item half module drop-shadow bottom" *ngIf="bulkState == 'sendscreenmessage'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">Message <button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element" (click)="editHow()"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main">
                    <div class="text-center">
                        <p class="md">{{interactionHow.message}}</p>
                    </div>
                </div>
            </div>

            <div class="dash-grid--item half module drop-shadow bottom" *ngIf="bulkState == 'applyloan'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">How<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element" (click)="editHow()"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main module--main__column">
                    <div class="block-num text-center">
                        <span class="lg">£{{interactionHow.value}}</span>
                        <span class="md">New loan amount</span>
                    </div>
                </div>
            </div>


            <div class="dash-grid--item half module summary__module bottom" *ngIf="bulkState == 'updatesupplytariffs'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">Updated Supply Tarrif<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element"  (click)="editHow()"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main no-border">
                    <div class="block-num text-center">
                        <svg class="ic" *ngIf="interactonData.how.supplyTarrifType == 'Standing Charge'"><use xlink:href="#ic-house" href="#ic-house"></use></svg>
                        <svg class="ic" *ngIf="interactonData.how.supplyTarrifType == 'Electricity'"><use xlink:href="#ic-elec" href="#ic-elec"></use></svg>
                        <svg class="ic" *ngIf="interactonData.how.supplyTarrifType == 'Gas'"><use xlink:href="#ic-gas" href="#ic-gas"></use></svg>
                        <svg class="ic" *ngIf="interactonData.how.supplyTarrifType == 'Heat'"><use xlink:href="#ic-heat" href="#ic-heat"></use></svg>
                        <svg class="ic" *ngIf="interactonData.how.supplyTarrifType == 'Hot Water'"><use xlink:href="#ic-hot-water" href="#ic-hot-water"></use></svg>

                        <h2 class="subheading-sm">{{interactonData.how.supplyTarrifType}}</h2>
                        <div class="summary__module--flex summary__module--flex__column__md">
                            <div class="flex--item">
                                <span class="lg">£{{interactonData.how.pastValue}} <span class="md u-display u-display__inline-block">per kWh</span></span>
                                <span class="md">Current supply tariff</span>
                            </div>
                            <div class="flex--item"></div>
                            <div class="flex--item">
                                <span class="lg">£{{interactonData.how.value}} <span class="md u-display u-display__inline-block">per kWh</span></span>
                                <span class="md">Updated supply tariff</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="dash-grid--item half module drop-shadow bottom" *ngIf="bulkState == 'changeeclimit'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">How<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element" (click)="editHow()"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main module--main__column">
                    <div class="block-num text-center">
                        <span class="lg">£{{interactionHow.value}}</span>
                        <span class="md">new E/C limit amount</span>
                    </div>
                </div>
            </div>

            <div class="dash-grid--item half module drop-shadow bottom" *ngIf="bulkState == 'ajustcredit'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">How<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element" (click)="editHow()"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="module--main module--main__column">
                    <div class="block-num text-center">
                        <span class="lg">£{{interactionHow.value}}</span>
                        <span class="md">Adjustment amount</span>
                    </div>
                </div>
            </div>

            <div class="dash-grid--item full-width module drop-shadow bottom" *ngIf="bulkState == 'updatefriendlydisconnect'">
                <div class="dashboard--module-header">
                    <h2 class="subheading-sm">How<button class="info-btn focus-element"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
                    <div class="btn-group">
                        <button class="focus-element" (click)="editHow()"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-9 col-sm-8 col-xs-12">
                        <table class="flex-grid--item std-table stacked-sm">
                            <thead>
                            <th>Day</th>
                            <th>Disconnect?</th>
                            <th>From</th>
                            <th>To</th>
                            </thead>
                            <tbody>
                                <tr><td data-label="Day">Saturday</td><td data-label="Disconnect?">{{friendlyDisconnect.saturday ? 'Yes' : 'No'}}</td><td data-label="From">{{formatTime24(friendlyDisconnect.saturdayStartTime)}}</td><td data-label="To">{{formatTime24(friendlyDisconnect.saturdayEndTime)}}</td></tr>
                                <tr><td data-label="Day">Sunday</td><td data-label="Disconnect?">{{friendlyDisconnect.sunday ? 'Yes' : 'No'}}</td><td data-label="From">{{formatTime24(friendlyDisconnect.sundayStartTime)}}</td><td data-label="To">{{formatTime24(friendlyDisconnect.sundayEndTime)}}</td></tr>
                                <tr><td data-label="Day">Weekday</td><td data-label="Disconnect?">{{friendlyDisconnect.weekdays ? 'Yes' : 'No'}}</td><td data-label="From">{{formatTime24(friendlyDisconnect.weekdayStartTime)}}</td><td data-label="To">{{formatTime24(friendlyDisconnect.weekdayEndTime)}}</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-3 col-sm-4 col-xs-12">
                        <form action="" class="flex-grid--item  std-form">
                            <div class="form-group">
                                <label class="text-left" style="font-weight: 700;padding: 0.25rem;">Special days</label>
                                <ul class="checklist">
                                    <li class="checklist--item" *ngFor="let specialDay of friendlySpecialDays"><input type="checkbox" id="client4" disabled><label for="client4">{{specialDay.date | date:'dd/MM/yyyy'}} <svg class="ic-check"><use xlink:href="#ic-check" href="#ic-check"></use></svg></label></li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <div class="btn-group btn-group__stacked-sm text-center">
            <button type="submit" (click)="submit()" class="std-btn focus-element"><span class="focus--content" tabindex="-1">Confirm</span></button>
            <button type="button" (click)="abandonPopup()" class="std-btn focus-element"><span class="focus--content" tabindex="-1">Abandon request</span></button>
        </div>
    </div>
</div>
